const selected_shape = 'Rectangle';
var base_price = 0;
var multiplier = 0.20;
var polish_multiplier = 0.35;
var polishing_price = 0;
let additionalPrice = 0;
var min_amount = 25.46;
const settings = {"color_text":"#3a3a3a","color_body_text":"#333232","color_sale_text":"#EA0606","color_button":"#3a3a3a","color_button_text":"#ffffff","color_small_button_text_border":"#3a3a3a","color_text_field_text":"#000000","color_text_field_border":"#cccccc","color_text_field":"#ffffff","color_image_overlay_text":"#ffffff","color_image_overlay":"#685858","image_overlay_opacity":40,"color_borders":"#ebebeb","color_body_bg":"#ffffff","type_header_font":{"error":"json not allowed for this object"},"type_header_base_size":26,"type_base_font":{"error":"json not allowed for this object"},"type_base_size":15,"predictive_search_enabled":true,"predictive_search_show_vendor":true,"predictive_search_show_price":true,"share_facebook":true,"share_twitter":true,"share_pinterest":true,"social_twitter_link":"","social_facebook_link":"https:\/\/www.facebook.com\/royaltymirror","social_pinterest_link":"#","social_instagram_link":"https:\/\/www.instagram.com\/royaltymirror\/","social_tumblr_link":"","social_snapchat_link":"","social_youtube_link":"https:\/\/www.youtube.com\/@royaltymirror2460","social_vimeo_link":"","favicon":"\/\/cdn.shopify.com\/s\/files\/1\/0507\/2597\/8291\/files\/favicon-32x32.png?v=1787130233","enable_ajax":false,"business_address":"1688 Meridian Ave, Suit 700\nMiami Beach, FL 33139","contact_info_email":"support@royaltymirror.com","contact_info_phone":"\u003ca href=\"tel:8005826775\"\u003e(800) 582-6775\u003c\/a\u003e","insulated_glass_multiplier":"0.22","multiplier_except_clear_glass":"0.25","argon_gas_multiplier":"0.024","insulated_glass_min_price":"181.81","insulated_glass_price_above_1000":"0","insulated_glass_price_above_1200":"50","insulated_glass_price_above_1500":"80","insulated_glass_price_above_2000":"500","insulated_glass_price_above_2500":"700","insulated_glass_price_above_3000":"800","insulated_glass_price_above_3500":"950","insulated_glass_price_above_4000":"1300","insulated_glass_price_above_4500":"1500","insulated_glass_price_above_5000":"1000","insulated_glass_price_above_10000":"1000","ultra_clear_glass_price":"60","gray_glass_price":"30","tint_bronze_glass_price":"30","frosted_glass_price":"50","black_glass_price":"50","custom_cut_glass_add_min_price":"7.57","custom_cut_glass_price_above_1000":"0","custom_cut_glass_price_above_1200":"90","custom_cut_glass_price_above_1500":"150","custom_cut_glass_price_above_2000":"500","custom_cut_glass_price_above_2500":"600","custom_cut_glass_price_above_3000":"700","custom_cut_glass_price_above_3500":"1200","custom_cut_glass_price_above_4000":"1800","custom_cut_glass_price_above_4500":"2000","custom_cut_glass_price_above_5000":"2500","custom_cut_glass_price_above_10000":"2700","custom_cut_glass_thickness_1_8":"0.168","custom_cut_glass_thickness_3_8":"0.230","custom_cut_glass_thickness_1_2":"0.250","custom_cut_glass_thickness_5_8":"0.700","mirror_multiplier":"0.20","mirror_polish_multiplier":"0.35","mirror_min_price":"25.46","mirror_price_above_1000":"0","mirror_price_above_1200":"70","mirror_price_above_1500":"100","mirror_price_above_2000":"500","mirror_price_above_2500":"705","mirror_price_above_3000":"1000","mirror_price_above_3500":"2000","mirror_price_above_4000":"2000","mirror_price_above_4500":"2100","mirror_price_above_5000":"2100","mirror_price_above_10000":"2100","mirror_beveled_polished_edge_disabled":false,"beveled_edge_disabled":false,"beveled_polished_edge_disabled":false,"seamed_edge_disabled":false,"pencil_polished_edge_disabled":true,"hs_6in_most_popular_price":"0","hs_8in_most_popular_price":"36.00","hs_6in_square_handle_price":"25.00","hs_8in_square_handle_price":"35.00","hs_6in_ladder_handle_price":"55.00","hs_8in_ladder_handle_price":"75.00","hs_knob_handle_price":"40.00","hs_towel_bar_price":"75.00","hs_pull_handle_price":"75.00","matte_black_hardware_price":"170","brushed_nickel_hardware_price":"150","oil_rubbed_bronze_hardware_price":"200","polished_brass_hardware_price":"170","polished_chrome_hardware_price":"150","polished_nickel_hardware_price":"170","satin_brass_hardware_price":"170","shower_door_thickness_3_8":"0.30","shower_door_thickness_1_2":"0.35","glass_table_top_delivery_text":"7-10 Business Days","mirrors_delivery_text":"7-10 Business Days","replacement_glass_delivery_text":"7-10 Business Days","glass_shelves_delivery_text":"7-10 Business Days","laminated_glass_delivery_text":"7-10 Business Days","tempered_glass_delivery_text":"7-10 Business Days","insulated_glass_delivery_text":"7-10 Business Days","shower_doors_delivery_text":"7-15 Business Days","shop_pay_enabled":false,"shop_pay_text":"Pay in full or in 4 interest-free installments of {amount}","order_summary_additional_information":"Safe Delivery Guaranteed","custom_cut_glass_thickness_3_4":"0.700","mirror_price_above_60":"100","mirror_flat_polished_edge_disabled":false,"checkout_logo_image":"shopify:\/\/shop_images\/Newlogo-dark.png","checkout_accent_color":"#000000","checkout_button_color":"#ffd814","checkout_layout":"onepage","insulated_glass_additional_price":"500","customer_layout":"customer_area"};
let finalUnitPrice = 0;
const min_area = 401;

function scroll_to_top() {
    $('html, body').animate({
      scrollTop: $('.custom-page-container').offset().top
    }, 1000);
}
 
var update_url = function( title ) {
    var obj = { Title: title, Url: '#'+ title };
    history.pushState(obj, obj.Title, obj.Url);

    showHideTestimonials(title);
}

var navigate_to_step = function (step, update_hash = true){
    if( step == '' ){
        step = 'select-dimensions';
    }

    if( update_hash ){
        update_url( step );
    }

    $('.tab--content').hide();
    $(".tab-containes-content").find(".tab--content[data-step='" + step + "']").show();

    $('.steps-grid ul li, .mobile_tabs').removeClass('active-tabs');
    $("[data-step='" + step + "']").addClass('active-tabs');

    scroll_to_top();
}

window.onhashchange = function() {
    var hash = window.location.hash.substring(1); //Puts hash in variable, and removes the # character
    navigate_to_step( hash, false );
}

$(document).on('click', '.active-tabs-head', function(){
  	var step = $(this).data('step');

    update_url(step);
    navigate_to_step(step);
});

function update_base_price(v1, v2){
   base_price = ( parseFloat(v1) + parseFloat(v2) ) * 2;
}

function update_polishing_price(){
  var title = $('input[name=select_edging]:checked').val();

  if( title == 'Flat Polished Edge' ){
      polishing_price = 0;
  }else{
      polishing_price = base_price * polish_multiplier;
  }
  console.log(polishing_price)
}

function get_initial_amount(){
	if(parseFloat($('.total_inch_space').val()) > 2500){
		return 0;
	}
	return 0;
}

const get_thickness_multiplier = (thickness) => {
    if(thickness == "1/8"){
        return 0.148;
    }
    else if(thickness == "5/32") {
        return 0.147;
    }
    else if(thickness == "3/16") {
        return 0.146;
    }
    else if(thickness == "1/4") {
        return 0.20;
    }
    else if(thickness == "3/8") {
        return 0.195;
    }
    else if(thickness == "1/2") {
        return 0.21;
    }
    else if(thickness == "3/4") {
        return 0.807;
    }
    return 1;
}

const calulate_item_surface_area = (width, height) => {
    surface_area = width * height;
    additionalPrice = getAdditionalPrice('mirror', surface_area, settings);
    console.log(`Additional price: ${additionalPrice}`);
}

const get_weight_thickness_multiplier = (thickness) => {
    switch(thickness) {
      case '1/8':
        return 0.0117;
      case '5/32':
        return 0.0169;
      case '3/16':
        return 0.0174;
      case '1/4':
        return 0.0224;
      case '3/8':
        return 0.0332;
      case '1/2':
        return 0.0442;
      case '5/8':
        return 0.0537;
      case '3/4':
        return 0.0632;
      default:
        return 1;
  }
}

const get_item_weight = () => {
    const thickness = $( "input[name=select_thickness]:checked").val();
    const thickness_multiplier = get_weight_thickness_multiplier(thickness);
    const item_weight = (surface_area * thickness_multiplier).toFixed(2);

    return item_weight + ' lbs';
}

const getTotalPrice_OLD = () => {
    let price = get_initial_amount();
    $('.counter_value').each(function() {
        price += parseFloat($(this).val());
    });
    price += additionalPrice;

    const recutProtectionCost = getGlassRecutProtectionCost();
    price += recutProtectionCost;

    return price;
}

function getTotalPrice() {
  console.log('Total price from new function')
  function getBasePrice(v1, v2){
     return ( parseFloat(v1) + parseFloat(v2) ) * 2;
  }

  function getThicknessPrice() {
    const thickness = $('input[name=select_thickness]:checked').val();
    const multiplier = get_thickness_multiplier(thickness);
    const totalSpace = $('.total_inch_space').val();

    let price = parseFloat(totalSpace) * multiplier;
    if(totalSpace <= 400) {
        price += parseFloat(min_amount);
    }

    // Increase price by 10%
    price += (price * 10) / 100

    return price;
  }

  function getGlassStrengthPrice() {
    return 0;
  }

  function getPolishingPrice(basePrice) {
    const edging = $('input[name=select_edging]:checked').val();

    if( edging == 'Flat Polished Edge' ) return 0;
    
    return basePrice * polish_multiplier;
  }

  function getCornerPrice(){
      var corner_price = parseFloat($('input[name=corner_finish]:checked').attr('data-type'));
      var price = corner_price;
      return price;
  }

  const length = $('#listOfDimensionValues206').val();
  const width = $('#listOfDimensionValues207').val();
  const basePrice = getBasePrice(length, width);

  const initialAmount = get_initial_amount();
  const thicknessPrice = getThicknessPrice();

  const glassStrengthPrice = getGlassStrengthPrice();
  const polishingPrice = getPolishingPrice(basePrice);
  const cornerPrice = getCornerPrice();

  const additionalPrice = getAdditionalPrice('mirror', length*width, settings);
  const recutProtectionCost = getGlassRecutProtectionCost();

  const total = initialAmount + thicknessPrice + glassStrengthPrice + polishingPrice + cornerPrice + additionalPrice + recutProtectionCost;

  console.log('Costs from new function are below:');  

  console.log('Thickness price :', thicknessPrice);
  console.log('Glass strength price :', glassStrengthPrice);
  console.log('Polishing price :', polishingPrice);
  console.log('Additional price :', additionalPrice);
  console.log('Recut protection cost :', recutProtectionCost);

  console.log('Total cost :', total);

  return parseFloat(total.toFixed(2));
}

const updatePriceDom = (price) => {
    $('.total_price').val(price);
    $('.price__ok').find('p').find('span').text('$ '+ price.toFixed(2) );

    $('.price__ok').each(function() {
      $(this).find('td:eq(1)').text('$ '+ price.toFixed(2));
    });
    $('.price_for_mobile strong').text('$ '+price.toFixed(2));

    document.querySelectorAll('.bp_thick_price').forEach(function(el) {
        const totalPrice = getTotalPrice();
        console.log("Pricc", totalPrice);
        el.textContent = '$ ' + getTotalPrice();
    });
}

const updateOrderSummaryDom = (totalPrice) => {
    const installmentAmount = totalPrice / 4;

    updatePriceDom(totalPrice);

    $('.total_cart').find('strong').text('$ '+totalPrice.toFixed(2));
    $('#installment_amount').text('$ ' + installmentAmount.toFixed(2));

    if( totalPrice > 3000 ){
        $('#installment_li').hide();
    }else{
        $('#installment_li').show();
    }
}

const calculateOrderTotals = () => {
  finalUnitPrice = getTotalPrice();
  const quantity = $('input[name=quantity]').val();
  const grandTotal = quantity * finalUnitPrice;
  console.log(grandTotal)
  updateOrderSummaryDom(grandTotal);
}

$( document ).ready(function() {

  update_url('select-dimensions');
  
  $( ".selection" ).click(function() {
    var imag = $(this).find('.image---').find('.next_step').attr('src');
    var title = $(this).find('p').text();

    if(title == "Rectangle" || title == "Oval/Ellipse" || title == "Race Track Oval") {
    	$('#listOfDimensionValues206-text').text('Length (L):');
        $('#listOfDimensionValues207-text').text('Width (W):');
    }
    else if(title == "Square") {
    	$('#listOfDimensionValues206-text').text('Length (W):');
    }
    else if( title == "Semi Circle" ) {
    	$('#listOfDimensionValues206-text').text('Length (H):');
    }
    else if( title == "Arch" ) {
    	$('#listOfDimensionValues206-text').text('Length (D):');
      	$('#listOfDimensionValues207-text').text('Height (H):');
    }
    else {
    	$('#listOfDimensionValues206-text').text('Height (H):');
      	$('#listOfDimensionValues207-text').text('Width (W):');
    }

    if(title == "Square" || title == "Rectangle" || title == "Oval/Ellipse" || title == "Race Track Oval") {
      $('.length-width').show();
      $( ".diamerter, .length2_width, .length3_width, .edge, .serface_leng_wid, .length2_width_heigth, .width2_height, .edge_leng_wid, .leng_width_edge2, .radius, .radiuscr, .height_width_ww" ).hide();
    }else if(title == "Round") {
      $('.diamerter').show();
      $('.length-width, .length2_width, .length3_width, .serface_leng_wid, .edge, .length2_width_heigth, .width2_height, .edge_leng_wid, .leng_width_edge2, .radius, .height_width_ww, .radiuscr').hide();        
    }else{
      window.location.href = "/pages/quotation";
    }

    $('.seleted_imag').attr('src','https:'+imag);
    $('.selected_shape').text(selected_shape);
    $('.selected_shape').val(selected_shape);
    update_url("select-dimensions");
  });

  $(".step-1-back").click(function() {
      $("#mob_tab_3").css("display", "none");
      $(".mob_tab3").css("display", "none");
      $("#mob_tab_2").css("display", "block");
      $(".mob_tab2").css("display", "block");
      $('[data-tab="tab-2"]').addClass('active-tabs');
      $('[data-tab="tab-3"]').removeClass('active-tabs');
      update_url("select-dimensions");
  });

  //dimensions click
  $( ".continue__tab-2" ).click(function() {
    $( "input[name=select_thickness]" ).each(function( index ) {
      $(this).prop('checked', false);
      
      if($(this).val() == "1/4") {
        
      $(this).prop('checked', true);
      }
    });

    $( "input[name=select_hole]" ).each(function( index ) {
      $(this).prop('checked', false);

      if($(this).val() == "No Hole") {
        $(this).prop('checked', true);
      }
    });

    $('.step4').val(0);
    
    var title = selected_shape;

    var first_val = $('#listOfDimensionValues206').val();
    var second_val = $('#listOfDimensionFractions_206').val();
    var third_val = $('#listOfDimensionValues207').val();
    var fourth_val = $('#listOfDimensionFractions_207').val();
    $('.desmino_mas').text('(L)' + first_val + '" ' + second_val + '" X (W)' + third_val + '" ' + fourth_val + '"');

    $('.cwidth').text(`Length - ${first_val}" ${second_val}"`);
    $('.cheight').text(`Width - ${third_val}" ${fourth_val}"`);

    $('.dim_length').val(first_val);
    $('.dim_frac_length').val(second_val);
    $('.dim_width').val(third_val);
    $('.dim_frac_width').val(fourth_val);
    var x = parseFloat(first_val) * parseFloat(third_val);  
    $('.total_inch_space').val(x);

    var adding_value = parseFloat(multiplier);
    var final_val = parseFloat(x) * parseFloat(multiplier); 

    $('.adding_value').val(adding_value);
    $('.step1').val(final_val);

    calulate_item_surface_area(first_val, third_val);
    update_base_price(first_val, third_val);
    update_polishing_price();

    const totalPrice = getTotalPrice();
    updatePriceDom(totalPrice);

    update_url("select-mirror-type");
  });


  $(".step-2-back").click(function() {
      $("#mob_tab_4").css("display", "none");
      $(".mob_tab4").css("display", "none");
      $("#mob_tab_3").css("display", "block");
      $(".mob_tab3").css("display", "block");
      $('[data-tab="tab-3"]').addClass('active-tabs');
      $('[data-tab="tab-4"]').removeClass('active-tabs');
      update_url("select-glass-type");
      document.querySelectorAll('.base-price').forEach(function(el) {
          el.textContent = '$ ' + getTotalPrice();
      });
  });

  $( ".continue__tab-3" ).click(function() {
    $( "input[name=select_thickness]" ).each(function( index ) {
      $(this).prop('checked', false);
      
      if($(this).val() == "1/4"){
        
      $(this).prop('checked', true);
      }
    });
    
    $( "input[name=select_hole]" ).each(function( index ) {
      $(this).prop('checked', false);
      
      if($(this).val() == "No Hole"){
        
      $(this).prop('checked', true);
      }
    });

    var value = $('input[name=glass_types]:checked').attr('data-price');      
    $('.selected_lens').text($('input[name=glass_types]:checked').val());
    var get = $('input[name=glass_types]:checked').val();  
    var price= "0";

    $('.step_glass').val(price);

    const totalPrice = getTotalPrice();
    updatePriceDom(totalPrice);

    update_url("select-thickness-hole-strength");
  });

  $('input[name=corner_finish], .corner-size, .corners-checkbox').change(function() {
    updateCornerFinish($(this));
  });

  function updateCornerFinish(ths) {
    $('.cornersize').hide();

    let cornerType = $('input[name="corner_finish"]:checked').val();
    let cornerFinish = '';

    if (cornerType != 'None') {
        const parent = ths.closest('li');
        parent.find('.cornersize').show();

        const cornerSize = parent.find('.corner-size').val();
        const selectedCorners = getSelectedCorners(parent);

        cornerFinish = `${cornerSize}" ${cornerType} With ${selectedCorners}`;
    } else {
        cornerFinish = cornerType;
    }

    $('.summery_column .selected_corner').text(cornerFinish);
  }

  const getSelectedCorners = (object) => {
    let selectedCorners = new Array();
    const cornerElements = object.find('.corners-checkbox:checked');

    cornerElements.each(function(){
        selectedCorners.push($(this).val());
    });

    const text = selectedCorners.join(', ');
    return text;
  }

  $( "#listOfDimensionValues206").change(function() {
    var val = $(this).val();
    var title = selected_shape;

    if(title == "Square" || title == "Semi Circle"){
      $('#listOfDimensionValues207 option[value='+val+']').attr('selected','selected');
    }
  });

  $( "#listOfDimensionValues207").change(function() {
    var val = $(this).val();
    var title = selected_shape;
    if(title == "Square" || title == "Semi Circle"){
      $('#listOfDimensionValues206 option[value='+val+']').attr('selected','selected');
    }
  });

  $('.select_demis').click(function() {
    $('.tab--content[data-tab="tab-2"]').fadeIn().siblings().fadeOut();
    $('.steps-grid>ul>li[data-tab="tab-2"]').addClass("active-tabs").siblings().removeClass("active-tabs");

  });
  $('.select_lens').click(function() {
    $('.tab--content[data-tab="tab-3"]').fadeIn().siblings().fadeOut();
    $('.steps-grid>ul>li[data-tab="tab-3"]').addClass("active-tabs").siblings().removeClass("active-tabs");
  });

  $('.select_thickness').click(function() {
    $('.tab--content[data-tab="tab-4"]').fadeIn().siblings().fadeOut();
    $('.steps-grid>ul>li[data-tab="tab-4"]').addClass("active-tabs").siblings().removeClass("active-tabs");
  });

  $('.select_edge').click(function() {
    $('.tab--content[data-tab="tab-5"]').fadeIn().siblings().fadeOut();
    $('.steps-grid>ul>li[data-tab="tab-5"]').addClass("active-tabs").siblings().removeClass("active-tabs");
  });

  $('.select_demis').click(function() {
    navigate_to_step('select-dimensions');
  });

  $('.select_lens').click(function() {
    navigate_to_step('select-mirror-type');
  });

  $('.select_thickness').click(function() {
    navigate_to_step('select-thickness-hole-strength');
  });

  $('.select_edge').click(function() {
    navigate_to_step('select-edging-corner-finish');
  });
  
  $('.glass-grid>ul>li.selection').click(function() {
    if($(".active-tabs-head").length > 1){
      $('.mob_tab1, .mob_tab2').addClass("active-tabs").siblings('mobile_tabs').removeClass("active-tabs");
    }
  });
  
  $('.glass-grid>ul>li.selection').click(function() {
  	$('#num2').addClass('active-tabs');
    $('#num1, #num3, #num4, #num5, #num6').removeClass('active-tabs');
  });

  $('.continue-btn').click(function(){
    var step = parseInt( $(this).data('step') ) + 1;
    $('.steps-grid li').removeClass('active-tabs');
    $('#num'+step).addClass('active-tabs');
  });


  $('.add').click(function () {
    if ($(this).prev().val() < 999) {
      var qty = parseInt($(this).prev().val()) + 1;
      $(this).prev().val(qty);

      calculateOrderTotals();
    }
  });

  $('.sub').click(function () {
    if ($(this).next().val() > 1) {
      	const qty = parseInt($(this).next().val()) - 1;
        $(this).next().val(qty);

        calculateOrderTotals();
    }
  });

  $('input[name=select_thickness]').click(function(){
    var change = $('input[name=select_thickness]:checked').val();
    var width = $('.dim_length').val();
    var heigth = $('.dim_width').val();

    var total_space = $('.total_inch_space').val();

    if(total_space <= 400){
      if(change == "1/8") {
        var efdsf = total_space * parseFloat(0.148);
        var final_value = parseFloat(efdsf) + min_amount;
      }else if(change == "5/32") {
        var efdsf = total_space * parseFloat(0.147);
        var final_value = parseFloat(efdsf) + min_amount;
      }else if(change == "3/16") {
        var efdsf = total_space * parseFloat(0.146);
        var final_value = parseFloat(efdsf) + min_amount;
      }else if(change == "1/4") {
        var efdsf = total_space * parseFloat(0.20);
        var final_value = parseFloat(efdsf) + min_amount;
      }else if(change == "3/8") {
        var efdsf = total_space * parseFloat(0.195);
         var final_value = parseFloat(efdsf) + min_amount;
      }else if(change == "1/2") {
        var efdsf = total_space * parseFloat(0.21);
        var final_value = parseFloat(efdsf) + min_amount;
      }else if(change == "3/4") {
        var efdsf = total_space * parseFloat(0.807);
        var final_value = parseFloat(efdsf) + min_amount;
      }

      $('.step1').val(final_value);

      const totalPrice = getTotalPrice();
      updatePriceDom(totalPrice);
    }

    if(total_space > 400) {

      if(change == "1/8") {
		var final_value = total_space * parseFloat(0.148);
      } else if(change == "5/32") {
		var final_value = total_space * parseFloat(0.147);
      } else if(change == "3/16") {
		var final_value = total_space * parseFloat(0.146);
      } else if(change == "1/4") {
		var final_value = total_space * parseFloat(0.20);
      } else if(change == "3/8") {
		var final_value = total_space * parseFloat(0.195);
      } else if(change == "1/2") {
		var final_value = total_space * parseFloat(0.21);
      } else if(change == "3/4") {
		var final_value = total_space * parseFloat(0.807);
      }

      console.log(final_value);
      $('.step1').val(final_value);

      const totalPrice = getTotalPrice();
      updatePriceDom(totalPrice);
    }
  });

  $('input[name=select_thickness-1]').click(function(){
    var total_space = $('.total_inch_space').val();

    if(total_space > 0){
      if($('input[name=select_thickness-1]:checked').val() == "Tempered Glass") {
        var final_value = total_space * parseFloat(0.0139);
        //var get_val = parseFloat($('.step1').val()) + parseFloat(final_value);
       var get_val = '20';
      }else{
        var final_value = total_space * parseFloat(0.0139);
      	//var get_val = parseFloat($('.step1').val()) - parseFloat(final_value);
        var get_val = '0';
      }      
      $('.step3').val(get_val);

      const totalPrice = getTotalPrice();
      updatePriceDom(totalPrice);
    }
  });

    $('input[name=select_hole]').change(function() {
        var change = $('input[name=select_hole]:checked').val();

        if(change == "Center Hole (Umbrella Hole)"){
            $('.step4').val('10');
        }else{
            $('.step4').val('0');
        }

        const totalPrice = getTotalPrice();
        updatePriceDom(totalPrice);
    });

    $(".step-3-back").click(function() {
        $("#mob_tab_5").css("display", "none");
        $(".mob_tab5").css("display", "none");
        $("#mob_tab_4").css("display", "block");
        $(".mob_tab4").css("display", "block");
        $('[data-tab="tab-4"]').addClass('active-tabs');
        $('[data-tab="tab-5"]').removeClass('active-tabs');
        update_url("select-thickness-hole-strength");
    });

   $( ".continue__tab-4" ).click(function() {
     var thickness =   $( "input[name=select_thickness]:checked").val();
     var hole = $( "input[name=select_hole]:checked").val();
     var glass = $( "input[name=select_thickness-1]:checked").val();

     $( "input[name=select_edging]" ).each(function( index ) {
      $(this).prop('checked', false);
      if($(this).val() == "Flat Polished Edge") {
        $(this).prop('checked', true); 
      }
     });

     update_polishing_price();
     
     $('.step5').val(polishing_price);

     if(hole == "Center Hole (Umbrella Hole)") {
       $('.step4').val('10');
     }else{
       $('.step4').val('0');
     }
     var total_space = $('.total_inch_space').val();
     if($('input[name=select_thickness-1]:checked').val() == "Tempered Glass") {
        var final_value = total_space * parseFloat(0.0139);
        //var get_val = parseFloat($('.step1').val()) + parseFloat(final_value);
       var get_val = '20';
      }else{
        var final_value = total_space * parseFloat(0.0139);
      	//var get_val = parseFloat($('.step1').val()) - parseFloat(final_value);
        var get_val = '0';
      }      
      $('.step3').val(get_val);
      var total_space = $('.total_inch_space').val();
      var change = thickness;
       if(change == "1/8"){
      var final_value = total_space * parseFloat(0.148);
        }else if(change == "5/32"){
      var final_value = total_space * parseFloat(0.147);
        }else if(change == "3/16"){
      var final_value = total_space * parseFloat(0.146);
        }else if(change == "1/4"){
      var final_value = total_space * parseFloat(0.20);
        }else if(change == "3/8"){
      var final_value = total_space * parseFloat(0.195);
        }else if(change == "1/2"){
      var final_value = total_space * parseFloat(0.21);
        }else if(change == "3/4"){
      var final_value = total_space * parseFloat(0.807);
        }
     var total_space = $('.total_inch_space').val();

      if(total_space <= 400) {
        if(change == "1/8"){
          var efdsf = total_space * parseFloat(0.148);
          var final_value = parseFloat(efdsf) + min_amount;
        }else if(change == "5/32") {
          var efdsf = total_space * parseFloat(0.147);
          var final_value = parseFloat(efdsf) + min_amount;
        }else if(change == "3/16") {
          var efdsf = total_space * parseFloat(0.146);
          var final_value = parseFloat(efdsf) + min_amount;
        }else if(change == "1/4") {
          var efdsf = total_space * parseFloat(0.20);
          var final_value = parseFloat(efdsf) + min_amount;
        }else if(change == "3/8") {
          var efdsf = total_space * parseFloat(0.195);
          var final_value = parseFloat(efdsf) + min_amount;
        }else if(change == "1/2") {
          var efdsf = total_space * parseFloat(0.21);
          var final_value = parseFloat(efdsf) + min_amount;
        }else if(change == "3/4") {
          var efdsf = total_space * parseFloat(0.807);
          var final_value = parseFloat(efdsf) + min_amount;
        }

        $('.step1').val(final_value);

        const totalPrice = getTotalPrice();
        updatePriceDom(totalPrice);
      }

      if(total_space > 400){
        if(change == "1/8"){
      var final_value = total_space * parseFloat(0.148);
        }else if(change == "5/32") {
      var final_value = total_space * parseFloat(0.147);
        }else if(change == "3/16") {
      var final_value = total_space * parseFloat(0.146);
        }else if(change == "1/4") {
      var final_value = total_space * parseFloat(0.20);
        }else if(change == "3/8") {
      var final_value = total_space * parseFloat(0.195);
        }else if(change == "1/2") {
      var final_value = total_space * parseFloat(0.21);
        }else if(change == "3/4") {
      var final_value = total_space * parseFloat(0.807);
        }
        console.log(final_value);
        $('.step1').val(final_value);

        const totalPrice = getTotalPrice();
        updatePriceDom(totalPrice);
      }
      $('.step1').val(final_value);
      // $('.glass_thickness').text(thickness+'" ' + hole+' ' + glass);
      // $('.Selected_tickness').text(thickness+'" || ' + hole+' || ' + glass);

      $('.glass_thickness').text(thickness+'" ' + glass);
      $('.Selected_tickness').text(thickness+'" ' + glass);

      update_url("select-edging-corner-finish");
    });

  $('input[name=select_edging]').click(function() {
      var edge = $('input[name=select_edging]:checked').val();
      if( edge == 'Beveled Edge') {
          $('#bevealed_size').removeClass('d-none');
      } else {
          $('#bevealed_size').addClass('d-none');
      }

      update_polishing_price();

      var price = polishing_price;
      $('.step5').val(price);

      const totalPrice = getTotalPrice();
      updateOrderSummaryDom(totalPrice);
  });

  $('input[name=corner_finish]').change(function(){
      const price = getTotalPrice();
      document.querySelectorAll('.base_n_thick_price').forEach(function(el) {
        el.textContent = '$ ' + price;
      });
  });
  
  $( ".continue__tab-5" ).click(function() {
    var value = polishing_price;
    var title = $('input[name=select_edging]:checked').val();

    if( title == 'Beveled Polished Edge' ){
        title = $('select[name=bevealed_edge_size]').val() + ' ' + title;
    }

    $('.step5').val(value);
    $('.selected_edge').text(title);

    updateCornerFinish($('input[name=corner_finish]:checked'));

    const totalPrice = getTotalPrice();
    updateOrderSummaryDom(totalPrice);

    $('.last_balue').val(totalPrice.toFixed(2));

    update_url("order-summary");
  });

  var get_properties = function() {
     const properties = {
        'Shape': selected_shape,
        'Dimensions': $('.glass_demesion').text(),
        'Mirror Type': $('.glass_type').text(),
        'Thickness': $('.glass_thickness').text(),
        'Edge': $('.glass_edeging').text(),
        'Corner Finish': $('.selected_corner').text(),
        'Glass Recut Protection': $('input[name=glass_recut_protection]:checked').val(),
     }

     const item_weight = get_item_weight();
     properties['Weight'] = item_weight;

     return properties;
  }

  $('input[name="glass_recut_protection"]').on('change', function() {
      calculateOrderTotals();
  });

  $('.buy_now_shipping').click(function () {

    calculateOrderTotals();
 
    $(this).addClass('loading');
    const properties = get_properties();
    const price = finalUnitPrice.toFixed(2);
    const data = {
        title: 'Custom Mirrors',
        price: price,
        properties: properties
    };

    const params = {
        type: 'POST',
        url: createShopifyProductUrl,
        data: data,
        dataType: "json"
    };

    $.ajax(params)
    .done(
      function(response) {
        var id = response.product.variants[0].id;
        var product_id = response.product.id;

        //Product created using shopify admin api.. add to cart it now.
        addToCart(id, properties);
      }.bind(this)
    )
    .fail(
      function(response) {
        console.log(response);
      }.bind(this)
    );
  });
});